/**
 * The tracker's chunk, behind a named function so a caller's decision not to fetch it is
 * observable — the same seam `loadLauncherRuntime` gives the launcher runtime. Mocking the
 * module it imports cannot show this: a gate moved below the import leaves `startPageViews`
 * uncalled either way, and the fetch is the thing the flag exists to prevent.
 *
 * A literal specifier, since the static-closure checks that keep this out of the
 * always-loaded tier cannot follow a computed one.
 */
export function loadPageViews(): Promise<typeof import('@/lib/beacon/startPageViews')> {
  return import('@/lib/beacon/startPageViews');
}
